module.exports = __webpack_public_path__ + "r-v3/img/logo_loading_white.111838cb.svg";